<script setup>
import CapaCalender from "@/views/incident/capa-calender/index.vue"

definePage({
  meta: {
    name: "capa-calender",
    subject: 'incident.menu',
    action: 'capa_calender',
  },
})
</script>

<template>
  <CapaCalender />
</template>
